import React, { Component } from "react";
import { withUser } from "@unifiedpatents/sso";
import { Layout, Menu } from "antd";
const { Sider, Content } = Layout;
import Toolbar from "./upc-toolbar";
import AppliedFilters from "../common/applied-filters";
import {
  keepOnlyUPCQueryStrings,
  mapUPCQueryStringToName,
} from "../../helpers/url";

class UPCSearch extends Component {
  render() {
    // Create the filter object from the query params.
    const filter = keepOnlyUPCQueryStrings(this.props.location.query);
    const { status: { isLoggedIn }, metadata: { authorization } } = this.props.user;
    const accessLevel = authorization.roles.indexOf("member-data") >= 0 ? "full" : isLoggedIn ? "guest" : "public";
    return (
      <Layout style={{ width: "100%", padding: 30 }}>
        <Sider
          width={250}
          breakpoint="lg"
          collapsedWidth="0"
          style={{ background: "transparent", marginRight: 16 }}
        >
          <Toolbar />
        </Sider>
        <Content>
          <AppliedFilters
            fieldSelector={keepOnlyUPCQueryStrings}
            fieldMapper={mapUPCQueryStringToName}
          />
          <Menu
            selectedKeys={[this.props.location.pathname]}
            onClick={this._onMenuClick}
            mode="horizontal"
          >
            <Menu.Item key="/upc/search">
              {"CASES"}
            </Menu.Item>
            <Menu.Item key="/upc/analytics">
              {"ANALYTICS"}
            </Menu.Item>
          </Menu>
          {React.cloneElement(this.props.children, {
            key: this.props.location.pathname + this.props.location.search,
            // This is how the filter object gets passed down to the child components like the table and the analytics.
            filter,
            accessLevel,
          })}
        </Content>
      </Layout>
    );
  }

  _onMenuClick = (item) => {
    const obj = keepOnlyUPCQueryStrings(this.props.location.query);
    this.props.router.push({
      pathname: item.key,
      query: obj
    });
  };
}

export default withUser(UPCSearch);